import Modal from 'LuxKit/Modal/Modal'
import BodyText from 'LuxKit/Typography/BodyText'
import React from 'react'
import { useIntl } from 'react-intl'

function CruisesDiscountTsAndCsModal() {
  const intl = useIntl()

  const termsAndConditionsText = intl.formatMessage({
    id: 'TcEF1eM/O8',
    defaultMessage: 'The savings percentage amounts are a comparison between the current lowest available fare and the current highest available fare on the same category, regardless of promotion. The savings percentage displayed reflects the highest available discount on any category on that sailing. Each fare level has its own terms and conditions. Prices displayed under the categories of inside, oceanview/outside, balcony & suite include all applicable discounts, savings & taxes and are per person prices based on twin occupancy in the cabin.',
    description: 'Terms and conditions text for cruise discount savings explanation',
  })

  return <Modal title={intl.formatMessage({
    id: 'ZXr7xV1Exx',
    defaultMessage: 'Terms and Conditions',
    description: 'Modal title for cruise discount terms and conditions',
  })}
  >
    <BodyText variant="large">{termsAndConditionsText}</BodyText>
  </Modal>
}

export default CruisesDiscountTsAndCsModal
